import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var KeyboardOutlineSVG = function KeyboardOutlineSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,6H3A1,1,0,0,0,2,7V23a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V7A1,1,0,0,0,29,6ZM28,22H4V8H28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "7",
    y: "10",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "11",
    y: "10",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "10",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "19",
    y: "10",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "23",
    y: "10",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "7",
    y: "14",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "11",
    y: "14",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "14",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "19",
    y: "14",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "23",
    y: "14",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "7",
    y: "18",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "11",
    y: "18",
    width: "10",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "23",
    y: "18",
    width: "2",
    height: "2"
  })));
};
KeyboardOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
KeyboardOutlineSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Keyboard")
};
export default withIcon(KeyboardOutlineSVG);